import { useDinPlayerContext } from 'hx-din-test-2';
import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';
export function usePreviewMode(enabled, setValue) {
    var _a = useDinPlayerContext(), state = _a.state, playTriplet = _a.playTriplet, stop = _a.stop;
    var _b = useState(false), paused = _b[0], setPaused = _b[1];
    var togglePaused = function () {
        if (paused)
            return setPaused(false);
        setPaused(true);
        setPreviewStepIndex(0);
    };
    var _c = useState(0), previewStepIndex = _c[0], setPreviewStepIndex = _c[1];
    var _d = useState(0), currentPreviewStepIndex = _d[0], setCurrentPreviewStepIndex = _d[1];
    var previewSteps = [
        function () {
            setValue === null || setValue === void 0 ? void 0 : setValue([]);
            playTriplet([4, 5, 6], {
                noNoise: true,
            });
        },
        function () {
            setValue === null || setValue === void 0 ? void 0 : setValue(['4']);
            // playAudioPreview();
        },
        function () { return setValue === null || setValue === void 0 ? void 0 : setValue(['4', '5']); },
        function () { return setValue === null || setValue === void 0 ? void 0 : setValue(['4', '5', '6']); },
    ];
    useEffect(function () {
        stop();
    }, [paused]);
    useInterval(function () {
        if (!enabled || paused)
            return;
        if (!setValue)
            throw new Error('You need to provide a setValue function to use preview mode');
        setCurrentPreviewStepIndex(previewStepIndex);
        setPreviewStepIndex(function (prev) { return (prev >= 3 ? 0 : prev + 1); });
        previewSteps[previewStepIndex]();
    }, paused || !enabled ? null : getDelayTimeForStep(currentPreviewStepIndex));
    return { togglePaused: togglePaused, paused: paused, state: state };
}
var getDelayTimeForStep = function (step) {
    switch (step) {
        case 0:
            return 500;
        case 3:
            return 1500;
        default:
            return 1000;
    }
};
